import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { ModulesService } from '../api/modules.service';

/**
 * U37 (issue #410) — Verfügbarkeits-Gate für Backend-Katalog-Module.
 *
 * Der Backend-Katalog trägt für `notifications` `Enabled: false` (T86 /
 * SDR-016): die Kachel rendert grau und nicht klickbar, und jeder Call,
 * den der Client macht, antwortet 404, weil das Portal-nginx die beiden
 * Endpunkte nicht mehr proxied. Dieser Guard hält Direkt-Links von der
 * Oberfläche fern, bis das Re-Hosting hinter dem Org-Service geht (T90).
 *
 * Heuristik: ein einzelner Katalog-Read über `ModulesService.list()` (kein
 * Polling — anders als der Visibility-Snapshot ist das ein einzelner GET).
 * Wenn das Modul fehlt oder `enabled` falsch ist, antwortet der Guard mit
 * einem UrlTree auf `/modules?notice=module_disabled` — dieselbe
 * Redirect-Form wie der welcomeGateGuard. Der Router ersetzt damit die
 * ganze Navigation inklusive History-Eintrag (replaceUrl für
 * browser-getriggerte Navigationen), und die Landing-Page rendert aus dem
 * Query-Parameter den übersetzten Hinweis. Erfolgsfall: erlaubt die Route.
 * Fehlerfall fail-closed.
 */
export const moduleEnabledGuard =
  (moduleId: string): CanMatchFn =>
  async () => {
    const modules = inject(ModulesService);
    const router = inject(Router);

    try {
      const catalog = await firstValueFrom(modules.list());
      const m = catalog.modules.find((entry) => entry.id === moduleId);
      if (m?.enabled) return true;
    } catch {
      // Katalog-Read fehlgeschlagen → fail-closed.
    }
    return router.createUrlTree(['/modules'], {
      queryParams: { notice: 'module_disabled' },
    });
  };
